export default __webpack_public_path__ + "static/media/successIcon.49c4a189.svg";